import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';

import { getMarketingScreenInfo } from 'app/src/getMarketingScreenInfo';
import { PowerUpsList } from './PowerUpsList';
import type { Plugins } from './types';

interface MadeByTrelloPageProps {
  readonly plugins: Plugins;
}

export const MadeByTrelloPage: FunctionComponent<MadeByTrelloPageProps> = ({
  plugins,
}) => {
  const intl = useIntl();
  useEffect(() => {
    const { url, referrerUrl, referrerScreenName } = getMarketingScreenInfo();
    Analytics.sendMarketingScreenEvent({
      url,
      referrerUrl,
      referrerScreenName,
      event: {
        source: 'publicDirectoryMadeByTrelloScreen',
        name: 'publicDirectoryMadeByTrelloScreenV2',
        attributes: {
          totalListed: plugins.length,
        },
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PowerUpsList
      title={intl.formatMessage({
        id: 'templates.directory.made-by-trello',
        defaultMessage: 'Made by Trello',
        description: 'Header for the Made by Trello page',
      })}
      plugins={plugins}
    />
  );
};
